module.exports = __webpack_public_path__ + "img/africa.fd8d12a9.jpg";